import { IHoliday } from "../holidayTypes";

export const DenmarkHolidays: { [key: string]: IHoliday } = {
  "2024-01-01": { title: "Nytårsdag", type: "HOLIDAY" },
  "2024-03-28": { title: "Skærtorsdag", type: "HOLIDAY" },
  "2024-03-29": { title: "Langfredag", type: "HOLIDAY" },
  "2024-03-31": { title: "Påskedag", type: "HOLIDAY" },
  "2024-04-01": { title: "2. påskedag", type: "HOLIDAY" },
  "2024-04-26": { title: "Store Bededag", type: "HOLIDAY" },
  "2024-05-09": { title: "Kristi Himmelfartsdag", type: "HOLIDAY" },
  "2024-05-19": { title: "Pinsedag", type: "HOLIDAY" },
  "2024-05-20": { title: "2. pinsedag", type: "HOLIDAY" },
  "2024-06-05": { title: "Grundlovsdag", type: "SPECIAL_DAY" },
  "2024-11-10": { title: "Mortensaften", type: "SPECIAL_DAY" },
  "2024-12-25": { title: "Juledag", type: "HOLIDAY" },
  "2024-12-26": { title: "2. juledag", type: "HOLIDAY" },
  
  // 2025
  "2025-01-01": { title: "Nytårsdag", type: "HOLIDAY" },
  "2025-02-02": { title: "Fastelavn", type: "SPECIAL_DAY" },
  "2025-04-17": { title: "Skærtorsdag", type: "HOLIDAY" },
  "2025-04-18": { title: "Langfredag", type: "HOLIDAY" },
  "2025-04-20": { title: "Påskedag", type: "HOLIDAY" },
  "2025-04-21": { title: "2. påskedag", type: "HOLIDAY" },
  "2025-05-01": { title: "Arbejdernes kampdag", type: "SPECIAL_DAY" },
  "2025-05-16": { title: "Store Bededag", type: "HOLIDAY" },
  "2025-05-29": { title: "Kristi Himmelfartsdag", type: "HOLIDAY" },
  "2025-06-05": { title: "Grundlovsdag", type: "SPECIAL_DAY" },
  "2025-06-08": { title: "Pinsedag", type: "HOLIDAY" },
  "2025-06-09": { title: "2. pinsedag", type: "HOLIDAY" },
  "2025-06-23": { title: "Sankt Hans aften", type: "SPECIAL_DAY" },
  "2025-11-10": { title: "Mortensaften", type: "SPECIAL_DAY" },
  "2025-12-24": { title: "Juleaften", type: "SPECIAL_DAY" },
  "2025-12-25": { title: "Juledag", type: "HOLIDAY" },
  "2025-12-26": { title: "2. juledag", type: "HOLIDAY" },
  "2025-12-31": { title: "Nytårsaften", type: "SPECIAL_DAY" },
  
  // 2026
  "2026-01-01": { title: "Nytårsdag", type: "HOLIDAY" },
  "2026-02-15": { title: "Fastelavn", type: "SPECIAL_DAY" },
  "2026-04-02": { title: "Skærtorsdag", type: "HOLIDAY" },
  "2026-04-03": { title: "Langfredag", type: "HOLIDAY" },
  "2026-04-05": { title: "Påskedag", type: "HOLIDAY" },
  "2026-04-06": { title: "2. påskedag", type: "HOLIDAY" },
  "2026-05-01": { title: "Arbejdernes kampdag", type: "SPECIAL_DAY" },
  "2026-05-14": { title: "Kristi Himmelfartsdag", type: "HOLIDAY" },
  "2026-05-24": { title: "Pinsedag", type: "HOLIDAY" },
  "2026-05-25": { title: "2. pinsedag", type: "HOLIDAY" },
  "2026-06-05": { title: "Grundlovsdag", type: "SPECIAL_DAY" },
  "2026-06-23": { title: "Sankt Hans aften", type: "SPECIAL_DAY" },
  "2026-11-10": { title: "Mortensaften", type: "SPECIAL_DAY" },
  "2026-12-24": { title: "Juleaften", type: "SPECIAL_DAY" },
  "2026-12-25": { title: "Juledag", type: "HOLIDAY" },
  "2026-12-26": { title: "2. juledag", type: "HOLIDAY" },
  "2026-12-31": { title: "Nytårsaften", type: "SPECIAL_DAY" },

  // 2027
  "2027-01-01": { title: "Nytårsdag", type: "HOLIDAY" },
  "2027-02-07": { title: "Fastelavn", type: "SPECIAL_DAY" },
  "2027-03-25": { title: "Skærtorsdag", type: "HOLIDAY" },
  "2027-03-26": { title: "Langfredag", type: "HOLIDAY" },
  "2027-03-28": { title: "Påskedag", type: "HOLIDAY" },
  "2027-03-29": { title: "2. påskedag", type: "HOLIDAY" },
  "2027-05-01": { title: "Arbejdernes kampdag", type: "SPECIAL_DAY" },
  "2027-05-06": { title: "Kristi Himmelfartsdag", type: "HOLIDAY" },
  "2027-05-16": { title: "Pinsedag", type: "HOLIDAY" },
  "2027-05-17": { title: "2. pinsedag", type: "HOLIDAY" },
  "2027-06-05": { title: "Grundlovsdag", type: "SPECIAL_DAY" },
  "2027-06-23": { title: "Sankt Hans aften", type: "SPECIAL_DAY" },
  "2027-11-10": { title: "Mortensaften", type: "SPECIAL_DAY" },
  "2027-12-24": { title: "Juleaften", type: "SPECIAL_DAY" },
  "2027-12-25": { title: "Juledag", type: "HOLIDAY" },
  "2027-12-26": { title: "2. juledag", type: "HOLIDAY" },
  "2027-12-31": { title: "Nytårsaften", type: "SPECIAL_DAY" }
};



// WEBPACK FOOTER //
// ./src/constants/holidays/europe/denmarkHolidays.ts